import { useLayoutEffect, useRef } from 'react';

/**
 * Keeps an element at the height it last had with data while it waits for a new coin's first frame (#1809, about 170 ms
 * after a side flip), so what sits below it does not jump up and back. Spread the result on the element.
 */
export function useKeptHeight<T extends HTMLElement>(ready: boolean) {
  const ref = useRef<T>(null);
  const height = useRef(0);
  useLayoutEffect(() => {
    if (ready && ref.current) height.current = ref.current.offsetHeight;
  });
  return { ref, style: !ready && height.current > 0 ? { minHeight: height.current } : undefined };
}
